module.exports = __webpack_public_path__ + "img/avatar-914.0ecdc7bb.png";